// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/pagination.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import { file_gitpod_tools_v1_stainless } from "../tools/v1/stainless_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/pagination.proto.
 */
export const file_gitpod_v1_pagination: GenFile = /*@__PURE__*/
  fileDesc("ChpnaXRwb2QvdjEvcGFnaW5hdGlvbi5wcm90bxIJZ2l0cG9kLnYxInIKEVBhZ2luYXRpb25SZXF1ZXN0EisKCXBhZ2Vfc2l6ZRgBIAEoBUIYukgGGgQYZCgAoqseCwoJcGFnZS5zaXplEg0KBXRva2VuGAIgASgJOiG6qx4dCgckc2hhcmVkEhJwYWdpbmF0aW9uX3JlcXVlc3QiTAoSUGFnaW5hdGlvblJlc3BvbnNlEhIKCm5leHRfdG9rZW4YASABKAk6IrqrHh4KByRzaGFyZWQSE3BhZ2luYXRpb25fcmVzcG9uc2UiXgoEU29ydBIfCgVmaWVsZBgBIAEoCUIQoqseDAoKc29ydC5maWVsZBI1CgVvcmRlchgCIAEoDjIULmdpdHBvZC52MS5Tb3J0T3JkZXJCEKKrHgwKCnNvcnQub3JkZXIiegoUQmlnUGFnaW5hdGlvblJlcXVlc3QSLAoJcGFnZV9zaXplGAEgASgFQhm6SAcaBRiQTigAoqseCwoJcGFnZS5zaXplEg0KBXRva2VuGAIgASgJOiW6qx4hCgckc2hhcmVkEhZiaWdfcGFnaW5hdGlvbl9yZXF1ZXN0KlAKCVNvcnRPcmRlchIaChZTT1JUX09SREVSX1VOU1BFQ0lGSUVEEAASEgoOU09SVF9PUkRFUl9BU0MQARITCg9TT1JUX09SREVSX0RFU0MQAkIsWipnaXRodWIuY29tL2dpdHBvZC1pby9naXRwb2QtbmV4dC9hcGkvZ28vdjFiBnByb3RvMw", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_tools_v1_stainless]);

/**
 * @generated from message gitpod.v1.PaginationRequest
 */
export type PaginationRequest = Message<"gitpod.v1.PaginationRequest"> & {
  /**
   * Page size is the maximum number of results to retrieve per page.
   * Defaults to 25. Maximum 100.
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * Token for the next set of results that was returned as next_token of a
   * PaginationResponse
   *
   * @generated from field: string token = 2;
   */
  token: string;
};

/**
 * Describes the message gitpod.v1.PaginationRequest.
 * Use `create(PaginationRequestSchema)` to create a new message.
 */
export const PaginationRequestSchema: GenMessage<PaginationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_pagination, 0);

/**
 * @generated from message gitpod.v1.PaginationResponse
 */
export type PaginationResponse = Message<"gitpod.v1.PaginationResponse"> & {
  /**
   * Token passed for retrieving the next set of results. Empty if there are no
   * more results
   *
   * @generated from field: string next_token = 1;
   */
  nextToken: string;
};

/**
 * Describes the message gitpod.v1.PaginationResponse.
 * Use `create(PaginationResponseSchema)` to create a new message.
 */
export const PaginationResponseSchema: GenMessage<PaginationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_pagination, 1);

/**
 * @generated from message gitpod.v1.Sort
 */
export type Sort = Message<"gitpod.v1.Sort"> & {
  /**
   * Field name to sort by, in camelCase.
   *
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: gitpod.v1.SortOrder order = 2;
   */
  order: SortOrder;
};

/**
 * Describes the message gitpod.v1.Sort.
 * Use `create(SortSchema)` to create a new message.
 */
export const SortSchema: GenMessage<Sort> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_pagination, 2);

/**
 * Do not use this in user facing APIs unless you have a good reason for that
 *
 * @generated from message gitpod.v1.BigPaginationRequest
 */
export type BigPaginationRequest = Message<"gitpod.v1.BigPaginationRequest"> & {
  /**
   * Page size is the maximum number of results to retrieve per page.
   * Defaults to 25. Maximum 10000.
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * Token for the next set of results that was returned as next_token of a
   * PaginationResponse
   *
   * @generated from field: string token = 2;
   */
  token: string;
};

/**
 * Describes the message gitpod.v1.BigPaginationRequest.
 * Use `create(BigPaginationRequestSchema)` to create a new message.
 */
export const BigPaginationRequestSchema: GenMessage<BigPaginationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_pagination, 3);

/**
 * @generated from enum gitpod.v1.SortOrder
 */
export enum SortOrder {
  /**
   * @generated from enum value: SORT_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SORT_ORDER_ASC = 1;
   */
  ASC = 1,

  /**
   * @generated from enum value: SORT_ORDER_DESC = 2;
   */
  DESC = 2,
}

/**
 * Describes the enum gitpod.v1.SortOrder.
 */
export const SortOrderSchema: GenEnum<SortOrder> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_pagination, 0);

